export default __webpack_public_path__ + "static/media/Icono_Mesas.54e08d56.png";